// src/Authentication/ForgotPassword.js

import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Auth.css";

const API = process.env.REACT_APP_API_URL;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!email) {
      alert("Please enter your email!");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${API}/auth/forgot-password`,
        { email }
      );

      alert(res.data.message);

      navigate("/reset-password", { state: { email } });

    } catch (error) {
      alert(error.response?.data?.error || "Error sending OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Forgot Password</h2>

      <input
        placeholder="Enter Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <button onClick={handleSubmit} disabled={loading}>
        {loading ? "Sending OTP..." : "Send OTP"}
      </button>
    </div>
  );
};

export default ForgotPassword;
